'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CmsPage = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactBodyClassname = require('react-body-classname');

var _reactBodyClassname2 = _interopRequireDefault(_reactBodyClassname);

var _FullPage = require('decorators/FullPage/FullPage');

var _isMobile = require('helpers/isMobile');

var _Metadata = require('components/Metadata/Metadata');

var _CmsModules = require('containers/CmsPage/CmsModules');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CmsPage = exports.CmsPage = function (_React$Component) {
  (0, _inherits3.default)(CmsPage, _React$Component);

  function CmsPage() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, CmsPage);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CmsPage.__proto__ || (0, _getPrototypeOf2.default)(CmsPage)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      clearedBanners: false
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(CmsPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          loadCmsPage = _props.loadCmsPage,
          path = _props.path;


      if (loadCmsPage) {
        loadCmsPage(path);
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props,
          hideFooter = _props2.hideFooter,
          hideHeader = _props2.hideHeader,
          modules = _props2.modules,
          useReducedFooter = _props2.useReducedFooter,
          useReducedNavigation = _props2.useReducedNavigation;


      if (hideHeader) {
        useReducedNavigation(true);
      }

      if (hideFooter) {
        useReducedFooter(true);
      }

      if (modules && modules.length) {
        this.runModuleTasks();
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props3 = this.props,
          clearBanners = _props3.clearBanners,
          loadCmsPage = _props3.loadCmsPage,
          path = _props3.path,
          modules = _props3.modules;

      // Banners need to be cleared for logged in users

      if (!this.state.clearedBanners && clearBanners) {
        clearBanners();
        this.setState(function () {
          return {
            clearedBanners: true
          };
        });
      }

      if (loadCmsPage && nextProps.path !== path) {
        this.stopModuleTasks();
        loadCmsPage(nextProps.path);
      }

      if (!modules.length && nextProps.modules && nextProps.modules.length) {
        this.runModuleTasks(nextProps.modules);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _props4 = this.props,
          hideFooter = _props4.hideFooter,
          hideHeader = _props4.hideHeader,
          useReducedFooter = _props4.useReducedFooter,
          useReducedNavigation = _props4.useReducedNavigation;


      this.stopModuleTasks();

      if (hideHeader) {
        useReducedNavigation(false);
      }

      if (hideFooter) {
        useReducedFooter(false);
      }
    }
  }, {
    key: 'runModuleTasks',
    value: function runModuleTasks(modules) {
      var _context = this.context,
          store = _context.store,
          client = _context.client;


      this.moduleSagas = (modules || this.props.modules).reduce(function (sagas, module) {
        var sagasToRun = [].concat(module.Component.watchSaga).filter(Boolean);
        sagasToRun.forEach(function (saga) {
          return store.runSaga(saga, client, module.props);
        });
        return sagas.concat(sagasToRun);
      }, []);
    }
  }, {
    key: 'stopModuleTasks',
    value: function stopModuleTasks() {
      var store = this.context.store;


      if (this.moduleSagas) {
        this.moduleSagas.forEach(store.stopSaga);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props5 = this.props,
          cmsData = _props5.cmsData,
          location = _props5.location,
          modules = _props5.modules;


      if (!modules) {
        return false;
      }

      return _react2.default.createElement(
        _reactBodyClassname2.default,
        {
          className: (0, _classnames2.default)((0, _defineProperty3.default)({}, _FullPage.FULLPAGE_CLASSNAME, location && (0, _isMobile.isWebview)(location.search)))
        },
        _react2.default.createElement(
          _react.Fragment,
          null,
          _react2.default.createElement(_Metadata.Metadata, cmsData && cmsData.metadata),
          _react2.default.createElement(_CmsModules.CmsModules, { modules: modules })
        )
      );
    }
  }]);
  return CmsPage;
}(_react2.default.Component);

CmsPage.contextTypes = {
  store: _propTypes2.default.object,
  client: _propTypes2.default.object
};

CmsPage.propTypes = {
  clearBanners: _propTypes2.default.func,
  loadCmsPage: _propTypes2.default.func,
  useReducedFooter: _propTypes2.default.func,
  useReducedNavigation: _propTypes2.default.func,
  cmsData: _propTypes2.default.shape({
    metadata: _propTypes2.default.object
  }),
  hideFooter: _propTypes2.default.bool,
  hideHeader: _propTypes2.default.bool,
  location: _propTypes2.default.object,
  modules: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    Component: _propTypes2.default.func,
    props: _propTypes2.default.object
  })),
  path: _propTypes2.default.string
};